import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ToasterErrorService } from '../_services/toaster.service';
import { ChangePasswordService } from '../_services/change-password.service';
import { GlobalsPaths } from '../app.config';

@Component({
  moduleId: module.id,
  selector: 'reset-password-app',
  templateUrl: `./reset-password.html`
})

export class ResetPasswordComponent implements OnInit {
  img: string = this.globalsPaths.img;
  toasterconfig: any = this.toasterErrorService.toasterconfig;
  resPass: string;
  repPass: string;
  tellUserToResetPassAgain: boolean = false;
  pageLoaded = false;
  constructor(
    private globalsPaths: GlobalsPaths,
    private toasterErrorService: ToasterErrorService,
    private changePasswordService: ChangePasswordService,
    private router: Router) { }

  ngOnInit() {
    const that = this;
    setTimeout(function () {
      that.pageLoaded = true;
    }, 1000);
  }

  newPassword(resPass, repPass) {
    if (resPass !== repPass) {
      this.toasterErrorService.toasterErr('new password and repeat password do not match!');
    } else if (resPass.length < 10) {
      this.toasterErrorService.toasterErr('password is shorter than the minimum length of 10 character!');
    } else {
      const token = window.location.search;
      const tokenSplit = token.split('?token=');
      this.changePasswordService.postResentPassword(tokenSplit[1], resPass)
        .subscribe(
          successData => {
            this.toasterErrorService.toasterSuccess(successData.message);
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 4000);
            console.log('Reset password: ', successData);
          },
          errData => {
            const _errorBody = JSON.parse(errData._body);
            if (_errorBody.status !== 'success') {
              this.tellUserToResetPassAgain = true;
            }
            this.toasterErrorService.toasterErr(_errorBody.message);
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Reset-password/reset-password.component.ts